import * as Constants from '../../constants';

import { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import classes from "./WalletFixasList.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlusCircle, faFileDownload, faFileUpload } from "@fortawesome/free-solid-svg-icons";

import { Button } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';

import RendaFixaForm from '../../components/RendaFixaForm';
import ScrollContainer from '../../components/UI/ScrollContainer';
import ConfirmDialog from '../../components/UI/ConfirmDialog';

import { CSVLink } from "react-csv";
import Papa from 'papaparse';

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const defaultFormAsset = { id: 0, ticker: 0, quotas: 0, price: 0 };

function WalletFixasList(props) {
  const csvUploadFileRef = useRef();
  const total = useSelector(state => state.total);

  const [fixas, setFixas] = useState([]);
  const [allFixas, setAllFixas] = useState([]);
  const [totalFixas, setTotalFixas] = useState(0);
  const [totalInvestidoFixas, setTotalInvestidoFixas] = useState(0);
  const [rentabilidadeTotal, setRentabilidadeTotal] = useState(0);
  const [formIsShown, setFormIsShown] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [deleteConfirmationIsShown, setDeleteConfirmationIsShown] = useState(false);
  const [deleteWalletConfirmationIsShown, setDeleteWalletConfirmationIsShown] = useState(false);
  const [selectedWalletItem, setSelectedWalletItem] = useState(defaultFormAsset);
  const threshold = localStorage.getItem('threshold');

  const finishSubmitAssetHandler = async () => {
    await fetchFixasHandler();
    hideFormHandler();
  };

  const hideFormHandler = () => {
    setFormIsShown(false);
  };

  const deleteConfirmationHandler = async () => {
    props.setIsLoading(true);
    try {
      const response = await fetch(Constants.DELETE_WALLET_FIXED_INCOME, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        mode: "cors",
        body: JSON.stringify({ id: selectedWalletItem.id })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Something went wrong!');
      }
    } catch (error) {
      console.error("DELETE_WALLET_FIXED_INCOME", error);
    }
    setSelectedWalletItem({});
    setDeleteConfirmationIsShown(false);
    fetchFixasHandler();
    props.onUpdateAssets(totalInvestidoFixas, totalFixas);
    props.setIsLoading(false);
  };

  const hideDeleteConfirmationHandler = () => {
    setDeleteConfirmationIsShown(false);
  };

  const hideDeleteWalletConfirmationHandler = () => {
    setDeleteWalletConfirmationIsShown(false);
  };


  const deleteHandler = (id) => {
    const title = fixas.filter((el) => { return el.id === id })[0].codigo;
    setSelectedWalletItem({ id, title });
    setDeleteConfirmationIsShown(true);
  };

  const addHandler = (id) => {
    setSelectedWalletItem(defaultFormAsset);
    setEditMode(false);
    setFormIsShown(true);
  };


  const deleteWalletConfirmationHandler = async () => {
    props.setIsLoading(true);
    try {
      // const response = await fetch(Constants.DELETE_WALLET_FIXED_INCOME, {
      //   method: "POST",
      //   headers: {
      //     'Accept': 'application/json',
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify({ "class": 0 })
      // });
      const response = await fetch(
        `${Constants.DELETE_WALLET_FIXED_INCOME}?id=${selectedWalletItem.id}`,
        {
          method: "DELETE",
          mode: "cors"
        }
      );

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
    } catch (error) {
    }
    setDeleteWalletConfirmationIsShown(false);
    fetchFixasHandler();
    props.onUpdateAssets(totalInvestidoFixas, totalFixas);
    props.setIsLoading(false);
  };

  const deleteWalletHandler = () => {
    // const title = fixas.filter((el) => { return el.id === id })[0].codigo;
    setDeleteWalletConfirmationIsShown(true);
  };

  const submitAssetListHandler = async (data) => {
    // console.log(data);
    let pData = [];
    data.forEach(asset => {
      const assetData = {
        id: asset[1],
        quotas: asset[0],
        averagePrice: asset[2]
        // averagePrice: asset[2].replace(",", ".")
      };
      pData.push(assetData);
    });
    // console.log(pData);
    const listData = {
      class: 1,
      data: pData
    }

    const id = localStorage.getItem("id");
    const url = `${Constants.ADD_ASSET_LIST}?id=${id}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(listData)
    });
    // console.log(response);
    // onFinishSubmit(pData);
  };

  const uploadButtonHandler = () => {
    csvUploadFileRef.current.click();
  };

  const csvUploadHandler = (event) => {
    const fileObj = event.target.files && event.target.files[0];
    // console.log(fileObj);

    Papa.parse(fileObj, {
      skipEmptyLines: true,
      complete: function (results) {
        // for (const entry of Object.entries(results.data)) {
        // console.log(results);
        submitAssetListHandler(results.data);
        // }
      }
    });

    fetchFixasHandler();
  };

  const editHandler = (id) => {
    const filtered = fixas.filter((el) => { return el.id === id })[0];
    const selected = allFixas.filter((el) => { return el.title === filtered.ticker })[0];

    setSelectedWalletItem({
      id,
      title: selected.title,
      maturity: selected.maturity,
      quantity: selected.quantity,
      indexer: selected.indexer,
      type: selected.type,
      invested: selected.invested,
      grossValue: selected.grossValue,
      netValue: selected.netValue,
      taxes: selected.taxes,
      grossProfit: selected.grossProfit,
      netProfit: selected.netProfit,
      ticker: Number(selected.id),
      quotas: Number(filtered.cotas),
      price: Number(filtered.price)
    });
    setEditMode(true);
    setFormIsShown(true);
  };

  const fetchAllFixasHandler = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(Constants.WALLET_FIXAS_LIST, {
          method: "GET",
          headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
          }
      });      

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
      const data = await response.json();
      setAllFixas(data);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  const fetchFixasHandler = useCallback(async () => {
    props.setIsLoading(true);
    let rentabilidade = 0;
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(Constants.WALLET_FIXAS_LIST, {
          method: "GET",
          headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
          }
      });

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }

      const data = await response.json();

      let sum = 0;
      let sumInvestido = 0;
      const loadedFixas = [];

      for (let item of data) {
        let investido = item.invested;

        let titulo = {
          id: item.id,
          ticker: item.title,
          vencimento: item.maturity,
          indice: item.indexer,
          tipo: item.type,
          cotas: item.quantity,
          price: item.invested / item.quantity,
          valorInvestido: investido,
          valorBruto: item.grossValue,
          valorLiquido: item.netValue,
          impostos: item.taxes,
          lucroBruto: item.grossProfit,
          lucroLiquido: item.netProfit,
          rentabilidadePercentual: (item.netValue - investido) / investido,
          rentabilidadeAbsoluta: (item.netValue - investido),
          parcelaTotalGeral: item.netValue
        }

        sum += titulo.valorLiquido;
        sumInvestido += titulo.valorInvestido;
        rentabilidade += titulo.rentabilidadeAbsoluta;
        loadedFixas.push(titulo);
      }
      setTotalFixas(sum);
      setTotalInvestidoFixas(sumInvestido);
      setFixas(loadedFixas);
      setRentabilidadeTotal(rentabilidade);
      props.onUpdateAssets(sumInvestido, sum);
      props.setIsLoading(false);
    } catch (error) {
      console.warn(error);
    }
    props.setIsLoading(false);
  }, [total, fixas]);

  useEffect(() => {
    fetchAllFixasHandler();
    fetchFixasHandler();
  }, []);

  useEffect(() => {
    props.onUpdateAssets(totalInvestidoFixas, totalFixas);
    props.setIsLoading(false);
    // updateRentabilidade();
  }, [total, totalFixas, fixas]);

  const csvDownloadHandler = () => {
    let fixasCopy = [];
    fixas.forEach(object => {
      const obj = {
        cotas: object.cotas,
        codigo: object.codigo,
        price: object.price,
        id: object.id
      }
      fixasCopy.push(obj);
    });
    return fixasCopy;
  }

  const confirmDeleteMessage = <>Tem certeza que deseja excluir o ativo <b>{selectedWalletItem.title}</b>?</>;
  const confirmDeleteWalletMessage = <>Tem certeza que deseja excluir todos os ativos?</>;

  return <>
    {formIsShown && <RendaFixaForm
      edit={editMode}
      active={selectedWalletItem}
      assets={allFixas}
      method="POST"
      onFinishSubmit={finishSubmitAssetHandler}
      onClose={hideFormHandler}
    />}
    {deleteConfirmationIsShown && <ConfirmDialog
      variant="warning"
      onConfirm={deleteConfirmationHandler}
      onCancel={hideDeleteConfirmationHandler}
      header="Atenção!"
      message={confirmDeleteMessage}
    />}
    {deleteWalletConfirmationIsShown && <ConfirmDialog
      variant="danger"
      onConfirm={deleteWalletConfirmationHandler}
      onCancel={hideDeleteWalletConfirmationHandler}
      header="Atenção!"
      message={confirmDeleteWalletMessage}
    />}

    {!props.isLoading &&
      <>
        <div className='row'>
          <div className='col col-md-2'>
            <Button onClick={addHandler} variant="primary" type="button" size="sm" className="m-1">
              <FontAwesomeIcon icon={faPlusCircle} />&nbsp;Adicionar
            </Button>

            <Button onClick={uploadButtonHandler} variant="outline-primary" type="button" size="sm" className="m-1" title="Enviar CSV">
              <input
                ref={csvUploadFileRef}
                onChange={csvUploadHandler}
                type="file"
                accept="text/csv"
                style={{ display: "none" }}
              />
              <FontAwesomeIcon icon={faFileUpload} />
            </Button>

            <CSVLink data={csvDownloadHandler()} filename={"fixas.csv"}>
              <Button variant="outline-success" type="button" size="sm" className="m-1" title="Baixar CSV">
                <FontAwesomeIcon icon={faFileDownload} />
              </Button>
            </CSVLink>

            <Button onClick={deleteWalletHandler} variant="outline-danger" type="button" size="sm" className="m-1">
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>

          <div className='col col-md-2'>
            <span className="fw-bold">Total Geral:</span> {isNaN(total) ? 0 : brlFormatter.format(total)}
          </div>

          <div className='col col-md-3'>
            <span className="fw-bold">Total Investido em Renda Fixa:</span><br /><small>{brlFormatter.format(totalInvestidoFixas)}</small>
          </div>

          <div className='col col-md-3'>
            <span className="fw-bold">Total em Renda Fixa:</span> {isNaN(totalFixas) || totalFixas === 0 ? '0%' : percentageFormatter.format(totalFixas / total)}<br /><small>{brlFormatter.format(totalFixas)}</small>
          </div>

          <div className="col col-md-2">
            <span className={(rentabilidadeTotal >= 0 ? 'fw-bold positive' : 'fw-bold negative')}>Rentabilidade:</span> {isNaN(rentabilidadeTotal) || rentabilidadeTotal === 0 ? '0%' : percentageFormatter.format(rentabilidadeTotal / totalFixas)}<br /><small>{brlFormatter.format(rentabilidadeTotal)}</small>
          </div>
        </div>

        <div className='row'>
          <div className='col col-md-12'>
            <ScrollContainer heightMultiplier={0.6337}>
              <Table striped bordered hover>
                <thead className={`fixedTableHead`}>
                  <tr>
                    <th rowSpan="2" className={classes.th}>Cotas</th>
                    <th rowSpan="2" className={classes.th}>Título</th>
                    <th rowSpan="2" className={classes.th}>Vencimento</th>
                    <th rowSpan="2" className={classes.th}>Índice</th>
                    <th rowSpan="2" className={classes.th}>Tipo</th>
                    <th colSpan="3" className={classes.th}>Valor</th>
                    <th colSpan="2" rowSpan='2' className={classes.th}>Impostos</th>
                    {/* <th colSpan="3" className={classes.th}>Lucro</th> */}
                    <th rowSpan="2" className={classes.th}>%<br />Geral</th>
                    <th colSpan="2" className={classes.th}>Rentabilidade</th>
                    <th rowSpan="2" className={classes.th}>Operações</th>
                  </tr>
                  <tr>
                    <th className={classes.th}>Aplicado</th>
                    <th className={classes.th}>Bruto</th>
                    <th className={classes.th}>Líquido</th>
                    <th className={classes.th}>%</th>
                    <th className={classes.th}>R$</th>
                  </tr>
                </thead>
                <tbody>
                  {fixas.length === 0 && <tr>
                    <td colSpan='20'>Nenhum ativo cadastrado.</td>
                  </tr>
                  }
                  {
                    fixas.map((titulo) => <tr key={titulo.id}>
                      <td className={classes.td}>{titulo.cotas}</td>
                      <td className={classes.td}>
                        <span className="font-weight-bolder">{titulo.ticker}</span><br />
                      </td>
                      <td className={[classes.td, "text-center"]}>{titulo.vencimento === '0000-00-00' ? '' : titulo.vencimento}</td>
                      <td className={classes.td}>{titulo.indice === 0 ? "NENHUM" : titulo.indice === 1 ? 'SELIC' : 'IPCA'}</td>
                      <td className={classes.td}>{titulo.tipo === 1 ? "PÚBLICO" : "PRIVADO"}</td>
                      <td className={classes.td}>{brlFormatter.format(titulo.valorInvestido)}</td>
                      <td className={classes.td}>{brlFormatter.format(titulo.valorBruto)}</td>
                      <td className={classes.td}>{brlFormatter.format(titulo.valorLiquido)}</td>
                      <td className={classes.td}>{brlFormatter.format(titulo.impostos)}</td>
                      <td className={classes.td}>{percentageFormatter.format(titulo.impostos / titulo.valorBruto)}</td>
                      <td className={classes.td + "" + (titulo.parcelaTotalGeral / total > threshold/100 ? " text-danger" : "")}>{percentageFormatter.format(titulo.parcelaTotalGeral / total)}</td>
                      <td className={classes.td + (titulo.rentabilidadePercentual < 0 ? " text-danger" : "")}>{percentageFormatter.format(titulo.rentabilidadePercentual)}</td>
                      <td className={classes.td + (titulo.rentabilidadeAbsoluta < 0 ? " text-danger" : "")}>{brlFormatter.format(titulo.rentabilidadeAbsoluta)}</td>
                      <td className={classes.td} style={{ textAlign: "center" }}>
                        <Link onClick={() => editHandler(titulo.id)}><FontAwesomeIcon icon={faEdit} /></Link>&nbsp;&nbsp;&nbsp;
                        <Link onClick={() => deleteHandler(titulo.id)}><FontAwesomeIcon icon={faTrash} /></Link>
                      </td>
                    </tr>
                    )
                  }
                </tbody>
              </Table>
            </ScrollContainer>
          </div>
        </div>
      </>
    }
  </>
}

export default WalletFixasList;
